import { Event, EventHint } from '@sentry/vue'

import { extractErrorMessageFromOrigException } from '../utils'

export const addUnhandledRejectionTrace = (event: Event, hint: EventHint) => {
  if (hint?.mechanism?.type === 'unhandledrejection' || hint?.mechanism?.type === 'onunhandledrejection') {
    if (hint?.originalException) {
      const errorMessage = extractErrorMessageFromOrigException(hint.originalException)
      event.tags = { ...event.tags, unhandledRejectionTrace: errorMessage }

      if (event.exception?.values) {
        for (var i = 0; i < event.exception.values.length; i++) {
          if (event.exception.values[i].value == undefined) {
            if (hint.originalException) {
              event.exception.values[i].type = hint.originalException.constructor.name + ' [unhandledrejection]'
              event.exception.values[i].value = errorMessage
            }
          }
        }
      }
    }
    return event
  }
  return false
}
